import { PoliciesSelectorWebComponent } from './component/PoliciesSelectorWebComponent';
import { WEB_COMPONENT_POLICIES_SELECTOR } from '../webcomponents.constants';

export { PoliciesSelectorWebComponent };

window.customElements.define(WEB_COMPONENT_POLICIES_SELECTOR, PoliciesSelectorWebComponent);
